<mat-icon svgIcon="{{iconName}}" aria-hidden="false"></mat-icon>